import React, { useRef, useState } from 'react';

/**
 * Pole drag&drop kreatora.
 *
 * WLASNY useRef na <input type=file> - CELOWO bez document.getElementById.
 * Karty importu 6/7 na stronie faktur uzywaja globalnych id ('cennik-only-xml',
 * 'csv-xml-csv'), wiec dwa egzemplarze w DOM trafialyby w ten sam input.
 *
 * stan: 'pusty' | 'wgrywanie' | 'blad' | 'ok'
 */
const WizardDropZone = ({
  tytul, opis, accept = '.xml', onPlik,
  disabled = false, disabledPowod = '', stan = 'pusty',
  postep = 0, nazwaPliku = ''
}) => {
  const inputRef = useRef(null);
  const [nadDropem, setNadDropem] = useState(false);

  const wgrywanie = stan === 'wgrywanie';
  const zablokowane = disabled || wgrywanie;

  const wybierz = () => {
    if (zablokowane) return;
    if (inputRef.current) inputRef.current.click();
  };

  const naZmianie = (e) => {
    const plik = e.target.files && e.target.files[0];
    // Reset wartosci - bez tego ponowny wybor TEGO SAMEGO pliku nie odpali onChange
    e.target.value = '';
    if (plik && onPlik) onPlik(plik);
  };

  const naDrop = (e) => {
    e.preventDefault();
    setNadDropem(false);
    if (zablokowane) return;
    const plik = e.dataTransfer.files && e.dataTransfer.files[0];
    if (plik && onPlik) onPlik(plik);
  };

  let kolorRamki = 'var(--border)';
  let tlo = 'var(--card-bg)';
  if (stan === 'blad') {
    kolorRamki = 'var(--danger)';
    tlo = 'var(--danger-light)';
  } else if (stan === 'ok') {
    kolorRamki = 'var(--success)';
    tlo = 'var(--success-light)';
  } else if (nadDropem) {
    kolorRamki = 'var(--primary)';
    tlo = 'var(--primary-light)';
  }

  return (
    <div>
      <div
        onClick={wybierz}
        onDragOver={(e) => { e.preventDefault(); if (!zablokowane) setNadDropem(true); }}
        onDragLeave={() => setNadDropem(false)}
        onDrop={naDrop}
        style={{
          border: `2px dashed ${zablokowane ? 'var(--border)' : kolorRamki}`,
          borderRadius: '8px',
          padding: '24px 16px',
          textAlign: 'center',
          backgroundColor: zablokowane ? 'var(--bg)' : tlo,
          cursor: zablokowane ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.55 : 1,
          transition: 'border-color 0.15s, background-color 0.15s'
        }}
      >
        <div style={{ fontSize: '24px', marginBottom: '6px' }}>
          {wgrywanie ? '⏳' : stan === 'blad' ? '⚠️' : stan === 'ok' ? '✅' : '📄'}
        </div>
        <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text)' }}>{tytul}</div>
        {opis && (
          <div style={{ fontSize: '10px', color: 'var(--text-muted)', marginTop: '4px' }}>{opis}</div>
        )}
        {nazwaPliku && (
          <div style={{ fontSize: '10px', color: 'var(--text-secondary)', marginTop: '4px', fontFamily: 'monospace' }}>
            {nazwaPliku}
          </div>
        )}
        {disabled && disabledPowod && (
          <div style={{ fontSize: '10px', color: 'var(--warning)', marginTop: '6px', fontWeight: '600' }}>
            {disabledPowod}
          </div>
        )}

        {wgrywanie && (
          <div style={{
            marginTop: '10px', height: '6px', borderRadius: '3px',
            backgroundColor: 'var(--border)', overflow: 'hidden'
          }}>
            <div style={{
              width: `${Math.max(0, Math.min(100, postep))}%`, height: '100%',
              backgroundColor: 'var(--primary)', transition: 'width 0.3s'
            }} />
          </div>
        )}

        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={naZmianie}
          style={{ display: 'none' }}
        />
      </div>
    </div>
  );
};

export default WizardDropZone;
